const SEARCH_ADMIN_MEDIA = `
  query searchAdmin($limit: Int, $offset: Int, $sort: String, $rawQuery: JSON!, $rawQueryAllResults: JSON!, $rawQueryImages: JSON!, $rawQueryVideos: JSON!, $rawQueryDocs: JSON!) {
    files: searchAdmin(limit: $limit, offset: $offset, sort: $sort, rawQuery: $rawQuery) {
      results {
        ...on File {
          mimetype
          id
          filename
          name
          url
          type
          updated
          data
          __typename
        }
      }
    }
    all: searchAdmin(limit: $limit, offset: $offset, sort: $sort, rawQuery: $rawQueryAllResults) {
      total
    }
    image: searchAdmin(limit: $limit, offset: $offset, sort: $sort, rawQuery: $rawQueryImages) {
      total
    }
    video: searchAdmin(limit: $limit, offset: $offset, sort: $sort, rawQuery: $rawQueryVideos) {
      total
    }
    text: searchAdmin(limit: $limit, offset: $offset, sort: $sort, rawQuery: $rawQueryDocs) {
      total
    }
  }
`;

const SEARCH_PUBLISHED_CONTENT = `
  query searchPublishedContent($rawQueryStringified: String!, $offset: Int, $limit: Int, $sort: String) {
    searchPublishedContent(rawQueryStringified: $rawQueryStringified, offset: $offset, limit: $limit, sort: $sort) {
      rawResults
    }
  }
`;

const SEARCH_ADMIN = `
  query searchAdmin($rawQueryStringified: String!, $offset: Int, $limit: Int, $sort: String) {
    search: searchAdmin(rawQueryStringified: $rawQueryStringified, offset: $offset, limit: $limit, sort: $sort) {
      rawResults
    }
  }
`;

export { SEARCH_ADMIN_MEDIA, SEARCH_PUBLISHED_CONTENT, SEARCH_ADMIN };
